<template>
  <div class="assigned-classlist">
    <div class="title-text brand_navy">ASSIGNED CLASSESS</div>

    <!-- CLASS NAME SECTION -->
    <template v-if="current_subject.assigned_classes.length">
      <span
        class="classname-holder rounded-30 pointer"
        :class="getActiveClass == class_data.id ? 'active-class' : null"
        v-for="(class_data, index) in current_subject.assigned_classes"
        :key="index"
        @click="switchClass(class_data.id)"
      >
        <span class="class-text">{{ class_data.class_name }}</span>
        <span class="icon icon-caret-right brand_accent font-14"></span>
      </span>
    </template>
    <!-- CLASS NAME SECTION -->

    <!-- ASIGN MORE CLASSESS -->
    <div class="assign-more-classes pointer" @click="$emit('showAssignClass')">
      <span class="icon-plus brand_accent"></span>
      <span class="text color_ash">Assign to more classes</span>
    </div>
    <!-- ASIGN MORE CLASSESS -->
  </div>
</template>

<script>
export default {
  name: "AssignedClassList",

  props: {
    current_subject: Object,
  },

  computed: {
    getActiveClass() {
      if (this.$route.query.class_id) return this.$route.query.class_id;
      else return this.current_subject.assigned_classes[0].id;
    },
  },

  data() {
    return {
      current_class: null,
    };
  },

  methods: {
    switchClass(id) {
      this.$router.push({
        name: "SchoolSettingsSubjectDetails",
        query: { subject: this.current_subject.slug, class_id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.assigned-classlist {
  .title-text {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 30px;

    @include breakpoint_max(lg) {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 18px;
    }
  }

  .classname-holder {
    display: table;
    padding: 13px 23px;
    margin-bottom: 2px;
    transition: all 0.4s ease-in-out;

    @include breakpoint_max(lg) {
      padding: 10px 18px;
    }

    .class-text {
      font-size: 14px;
      line-height: 19px;
      color: $color_ash;
      transition: all 0.4s ease-in-out;

      @include breakpoint_max(lg) {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .icon {
      top: 50%;
      transform: translateY(-50%);
      margin-left: 30px;
      display: none;
      transition: all 0.5s ease-in-out;

      @include breakpoint_max(lg) {
        font-size: 10px;
      }
    }

    &:hover {
      background: #fff;

      .class-text {
        color: $brand_primary;
        font-weight: bold;
      }

      .icon {
        display: unset;
      }
    }
  }

  .active-class {
    background: #fff;

    .class-text {
      color: $brand_primary;
      font-weight: bold;
    }

    .icon {
      display: unset;
    }
  }

  .assign-more-classes {
    display: table;
    padding: 11px 24px 12px;
    margin-top: 15px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='7' ry='7' stroke='%23959595FF' stroke-width='2' stroke-dasharray='10%2c 8' stroke-dashoffset='2' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 7px;
    transition: all 0.5s ease-in-out;

    @include breakpoint_max(lg) {
      padding: 8px 20px 9px;
    }

    span {
      margin-right: 10px;
      font-size: 18px;

      @include breakpoint_max(lg) {
        font-size: 14px;
      }
    }
    .text {
      font-size: 14px;
      transition: all 0.4s ease-in-out;

      @include breakpoint_max(lg) {
        font-size: 12px;
      }
    }

    &:hover {
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='7' ry='7' stroke='%23FAA017FF' stroke-width='2' stroke-dasharray='10%2c 8' stroke-dashoffset='2' stroke-linecap='square'/%3e%3c/svg%3e");

      .text {
        color: darken($brand_accent, 10) !important;
      }
    }
  }
}
</style>
